<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <form
            @submit.prevent="submit()"
            :class="{ 'disabled-form': disabled }"
          >
            <div class="p-2">
              <!--              <div class="mb-3">-->
              <!--                <label class="form-label" for="date">Date</label>-->
              <!--                <DateInput-->
              <!--                  id="date"-->
              <!--                  name="date"-->
              <!--                  placeholder="Enter Date"-->
              <!--                  type="text"-->
              <!--                  class="form-control"-->
              <!--                  v-model="updatedDistributor.date"-->
              <!--                  :disabled="disabled"-->
              <!--                />-->
              <!--              </div>-->

              <div class="mb-3">
                <label class="form-label" for="distributor">Supplier</label>
                <input
                  id="distributor"
                  name="distributor"
                  placeholder="Enter Supplier Name"
                  type="text"
                  class="form-control"
                  v-model="updatedDistributor.company"
                  :disabled="disabled"
                />
              </div>

              <div class="mb-3">
                <label class="form-label" for="name">Name</label>
                <input
                  id="name"
                  name="name"
                  placeholder="Enter Name"
                  type="text"
                  class="form-control"
                  v-model="updatedDistributor.name"
                  :disabled="disabled"
                />
              </div>

              <div class="mb-3">
                <label class="form-label" for="category">Email</label>
                <input
                  id="email"
                  name="email"
                  placeholder="Enter Email"
                  type="text"
                  class="form-control"
                  v-model="updatedDistributor.email"
                  :disabled="disabled"
                />
              </div>

              <div class="mb-3">
                <label class="form-label" for="category">Phone</label>
                <input
                  id="phone"
                  name="phone"
                  placeholder="Enter Phone"
                  type="text"
                  class="form-control"
                  v-model="updatedDistributor.phone"
                  :disabled="disabled"
                />
              </div>

              <div class="mb-3">
                <label class="form-label" for="category">Address</label>
                <input
                  id="address"
                  name="address"
                  placeholder="Enter Address"
                  type="text"
                  class="form-control"
                  v-model="updatedDistributor.address"
                  :disabled="disabled"
                />
              </div>

              <div class="hstack gap-2 mt-4">
                <button v-if="!disabled" type="submit" class="btn btn-primary">
                  Save
                </button>
                <button
                  v-if="disabled"
                  type="button"
                  class="btn btn-primary"
                  @click="edit"
                >
                  Edit
                </button>
                <button type="button" class="btn btn-light" @click="discard">
                  Back
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DateInput from "@/components/utils/DateInput";

export default {
  name: "DistributorForm",
  // components: { DateInput },
  props: {
    distributor: {
      type: Object,
      required: true,
    },
    submitFunction: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      updatedDistributor: { ...this.distributor },
    };
  },
  methods: {
    submit() {
      if (!this.disabled) {
        this.submitFunction(this.updatedDistributor);
      }
    },
    discard() {
      this.updatedDistributor = { ...this.distributor };
      this.$router.push("/distributors/");
    },
    edit() {
      this.$router.push("/distributors/edit/" + this.distributor.id);
    },
  },
  computed: {
    disabled() {
      return typeof this.submitFunction !== "function";
    },
  },
};
</script>
